import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  pageTitle: () => __(translations.interactionsTab.pageTitle, 'Interactions ({{count}})'),
  add: () => __(translations.interactionsTab.add, 'Add'),
  today: () => __(translations.interactionsTab.today, 'Today'),
  creation: () => __(translations.interactionsTab.creation, 'Creation'),
};
